<template>
  <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
    <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
      <div class="flex flex-wrap items-center">
        <div class="relative w-full max-w-full flex-grow flex-1">
          <h6 class="uppercase text-blueGray-400 mb-1 text-xs font-semibold" v-if="subtitle">
            {{ $t(subtitle) }}
          </h6>
          <h2 class="text-blueGray-700 text-xl font-semibold" v-if="title">
            {{ $t(title) }}
          </h2>
        </div>
      </div>
    </div>
    <div class="p-4 flex-auto">
      <div class="relative h-350-px" ref="chartContainer">
        <canvas ref="canvas"></canvas>
      </div>
    </div>
  </div>
</template>
<script>
import Chart from "chart.js";
export default {
  props: {
    records: {},
    label: {},
    value: {},
    subtitle: {},
    title: {},
    datasets: {},
    datasetName: {}
  },

  data() {
    return {
      chart: null
    }
  },

  computed: {
    config() {
      return {
        type: "bar",
        data: {
          labels: this.records?.map((item) => item[this.label]),
          datasets: this.datasets ? this.datasets : [
            {
              label: this.datasetName || this.title,
              backgroundColor: "#ed64a6",
              borderColor: "#ed64a6",
              data: this.records?.map((item) => item[this.value]),
              fill: false,
              barThickness: 8,
            },
          ],
        },
        options: {
          maintainAspectRatio: false,
          responsive: true,
          title: {
            display: false,
            text: this.title,
          },
          tooltips: {
            mode: "index",
            intersect: false,
          },
          hover: {
            mode: "nearest",
            intersect: true,
          },
          legend: {
            labels: {
              fontColor: "rgba(0,0,0,.4)",
            },
            align: "end",
            position: "bottom",
          },
          scales: {
            xAxes: [
              {
                display: true,
                scaleLabel: {
                  display: !!this.datasetName,
                  labelString: this.datasetName,
                },
                gridLines: {
                  borderDash: [2],
                  borderDashOffset: [2],
                  color: "rgba(33, 37, 41, 0.3)",
                  zeroLineColor: "rgba(33, 37, 41, 0.3)",
                  zeroLineBorderDash: [2],
                  zeroLineBorderDashOffset: [2],
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true
                },
                display: true,
                scaleLabel: {
                  display: false,
                  labelString: "Value",
                },
                gridLines: {
                  borderDash: [2],
                  drawBorder: false,
                  borderDashOffset: [2],
                  color: "rgba(33, 37, 41, 0.2)",
                  zeroLineColor: "rgba(33, 37, 41, 0.15)",
                  zeroLineBorderDash: [2],
                  zeroLineBorderDashOffset: [2],
                },
              },
            ],
          },
        },
      };
    }
  },

  watch: {
    config: {
      immediate: true,
      handler() {
        this.$nextTick(function () {
          if (this.chart) {
            this.chart.data = this.config.data;
            this.chart.options = this.config.options;
            this.chart.update();
          } else {
            const canvas = this.$refs.canvas;
            const ctx = canvas.getContext('2d');
            this.chart = new Chart(ctx, this.config);
          }
        });
      },
    },
  },
};
</script>
